import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { CastersProvider } from "./CastersContext";
import { CastersPage } from "./CastersPage";
import dataEntries from "./styles/useDataEntryStyles";

type Props = {};
const CasterDataEntryV2 = (props: Props) => {
	return (
		<MuiThemeProvider theme={dataEntries}>
			<CastersProvider>
				<CastersPage />
			</CastersProvider>
		</MuiThemeProvider>
	);
};
export default CasterDataEntryV2;
